<div id="wl-header" class="flex flex-col items-center justify-center">
  <div class="flex flex-row w-full relative items-center h-full header-row">
    <div class="flex flex-row w-full items-center">
      <div class="flex flex-1">
        <div class="title flex flex-col align-center justify-center">
          <h1 class="text-20">Whitelabel</h1>
        </div>
      </div>
      <div class="auth flex flex-row items-center">
        <language-switcher></language-switcher>
        <button
          class="theme-toggle-btn bg-b-secondary-bg text-b-secondary-color rounded-btn-radius w-10 h-10 flex items-center justify-center"
          type="button"
          (click)="toggleTheme()"
        >
          <i class="fa-regular fa-sun-bright" *ngIf="!isDarkTheme"></i>
          <i class="fa-sharp fa-solid fa-moon" *ngIf="isDarkTheme"></i>
        </button>
        <button
          class="customizer-toggle-btn bg-b-secondary-bg text-b-secondary-color rounded-btn-radius w-10 h-10 flex items-center justify-center"
          type="button"
          (click)="toggleCustomizer.emit()"
        >
          <i class="fa-sharp fa-solid fa-gear" *ngIf="!customizerVisible"></i>
          <i class="fa-regular fa-xmark" *ngIf="customizerVisible"></i>
        </button>
        <button
          class="auth-toggle-btn bg-b-primary-bg text-b-primary-color rounded-btn-radius w-16 h-10"
          (click)="showBox = !showBox"
        >
          <span>{{ isLoggedIn ? 'Logged in' : 'Auth' }}</span>
        </button>
      </div>
    </div>
    <span *ngIf="showBox">
      <header-auth-box
        [isLoggedIn]="isLoggedIn"
        [userInfo]="userInfo"
        [user]="user"
        [newUser]="newUser"
        [currencies]="currencies"
        (login)="login()"
        (register)="register()"
        (logout)="logout()"
      ></header-auth-box>
    </span>
  </div>
</div>
